import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { groupedFieldsStyle } from '../TransitionStyles';
import { validateRequiredNameWhenHasFiles } from '../ValidateFunctions';
import FileDrop from './FormInputs/FileDrop';
import TextInput from './FormInputs/TextInput';

FormTextWithFileDrop.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
  textFieldName: PropTypes.string,
  requireNameWhenHasFiles: PropTypes.bool,
};

export default function FormTextWithFileDrop({
  fieldName,
  focusedField,
  setFocusedField,
  fieldAttributes,
  textFieldName = 'answer',
  requireNameWhenHasFiles = false,
}) {
  const { control, getValues, watch } = useFormContext();

  const rowFiles = watch(`${fieldName}.files`) || [];
  const hasActiveFiles = rowFiles.some((file) => !file?.deleteFlag);

  const fieldArrayMethods = useFieldArray({
    control,
    name: `${fieldName}.files`,
    keyName: '_id',
  });

  const onFileAdded = (files) => {
    files.forEach((res) => {
      fieldArrayMethods.append(res[0]);
    });
  };

  const onFileRemoved = (file) => {
    const fileToRemove = getValues(fieldName)?.files?.findIndex((f) => f.id === file.id);
    fieldArrayMethods.update(fileToRemove, file);
  };

  return (
    <Grid sx={{ backgroundColor: '#f1f3f4cc', ...groupedFieldsStyle }}>
      <Controller
        name={`${fieldName}.${textFieldName}`}
        control={control}
        rules={{
          required: fieldAttributes?.validation?.required ?? undefined,
          validate: (value) =>
            !requireNameWhenHasFiles ? true : validateRequiredNameWhenHasFiles(value, hasActiveFiles),
          minLength: fieldAttributes?.validation?.minLength ?? undefined,
          pattern: fieldAttributes?.validation?.pattern
            ? {
                value: new RegExp(fieldAttributes?.validation?.pattern.value),
                message: fieldAttributes?.validation?.pattern.message,
              }
            : undefined,
        }}
        render={() => (
          <TextInput
            fieldName={`${fieldName}.${textFieldName}`}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={fieldAttributes}
            multiline={false}
          />
        )}
      />
      <Controller
        name={`${fieldName}.files`}
        control={control}
        render={() => (
          <FileDrop
            fieldAttributes={fieldAttributes}
            onFileRemoved={onFileRemoved}
            onFileAdded={onFileAdded}
            files={fieldArrayMethods.fields?.filter((f) => !f.deleteFlag) ?? []}
          />
        )}
      />
    </Grid>
  );
}
